import _ from 'lodash';
import { LocalStorageService } from 'services/data-handler-services/web-storage-service';

// ArrayStorageWrapper

// Provides a subset of the Array API against a single key
// wraps localStorage or an object based on support
function ArrayStorageWrapper(key) {
  this.key = key;
  this.storage = LocalStorageService;
  this.init();
}

ArrayStorageWrapper.prototype = {
  // init array in storage
  // if not present or is broken JSON
  init: function () {
    const set = this.storage.getItem(this.key);
    if (!_.isArray(set)) {
      this.storage.setItem(this.key, []);
      this.length = 0;
    }
  },

  _get: function () {
    const set = this.storage.getItem(this.key);
    this.length = set.length;
    return set;
  },

  _set: function (set) {
    this.length = set.length;
    return this.storage.setItem(this.key, set);
  },

  push: function (item) {
    const set = this._get();
    set.push(item);
    this._set(set);
  },

  shift: function () {
    const set = this._get();
    const item = set.shift(item);
    this._set(set);
    return item;
  },

  concat: function (arr) {
    let set = this._get();
    if (arr instanceof ArrayStorageWrapper) {
      arr = arr.toArray();
    }
    set = set.concat(arr);
    this._set(set);
  },

  splice: function (i, n) {
    const set = this._get();
    const spliced = set.splice(i, n);
    this._set(set);
    return spliced;
  },

  clear: function () {
    this._set([]);
  },

  slice: function (i, n) {
    const set = this._get();
    return set.slice(i, n);
  },

  toArray: function () {
    return this._get();
  },
};

export default ArrayStorageWrapper;
